import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Env from '../config/env';
import Colors from '../config/colors';

function Copyright() {
    return (
        <Typography variant="body2" style={{ color: '#000000', fontWeight:'bold', textAlign: 'center' }}>
            {`${Env.ApplicationName} ${Env.version}`}
            {' - Copyright © '}
            {new Date().getFullYear()}
            {`. ${Env.Company}`}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    main: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(2),
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: '2%',
        backgroundColor: Colors.accent,
        opacity: '0.7',
        left: 0,
        bottom: 0,
    },
}));

export default function StickyFooter() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <footer className={classes.footer}>
                <Container maxWidth="sm">
                    <Copyright />
                </Container>
            </footer>
        </div>
    );
}